<template>
    <div class="content_box mobile_msg_desc">
        <div class="content role">
            <div class="title_box">
                <span class="title">消息推送管理</span>
            </div>
            <div class="search_box">
                <el-form :inline="true" class="demo-form-inline search-form form-list" label-width="100px">
                    <el-form-item>
                        <el-input placeholder="标题" clearable v-model="searchData.name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.state" clearable placeholder="状态">
                            <el-option label="待发送" :value="0"></el-option>
                            <el-option label="已发送" :value="1"></el-option>
                            <el-option label="发送中" :value="-1"></el-option>
                            <el-option label="已过期" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="button button2 add" @click="addPush" v-if="roleCheck('103-102-102-102')">
                <i class="el-icon-plus"></i>
                <span>新增</span>
            </div>
            <el-table highlight-current-row :data="listData" style="width: 100%">
                <el-table-column prop="id" label="ID" width="100"></el-table-column>
                <el-table-column prop="msg_title" label="标题" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="msg_desc" label="内容" min-width="300" show-overflow-tooltip></el-table-column>
                <el-table-column prop="group_name" label="发送群组" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.group_name.join('；') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="user_count" label="总数量">
                    <template slot-scope="scope">
                        <span>{{ scope.row.user_count || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="send_count" label="发送数量">
                    <template slot-scope="scope">
                        <span>{{ scope.row.send_count || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="received" label="送达率">
                    <template slot-scope="scope">
                        <span>{{ scope.row.received || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="start_time" label="发送时间" width="150">
                    <template slot-scope="scope">
                        <span>{{ formDate(scope.row.start_time, 'YYYY-MM-DD HH:mm') }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="state">
                    <template slot-scope="scope">
                        <span class="status1" v-if="scope.row.state == 1">已发送</span>
                        <span class="status0" v-if="scope.row.state == 0">待发送</span>
                        <span class="status2" v-if="scope.row.state == -1">发送中</span>
                        <span class="status3" v-if="scope.row.state == 3">已过期</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="100">
                    <template slot-scope="scope">
                        <div>
                            <div class="button text" @click="msgShow(scope.row, 'update')"
                                v-if="roleCheck('103-102-102-102') && scope.row.state != -1 && scope.row.state != 1">编辑
                            </div>
                            <div class="button text" @click="del(scope.row.id)"
                                v-if="roleCheck('103-102-102-103') && scope.row.state != -1 && scope.row.state != 1">删除
                            </div>
                            <div class="button text" @click="msgShow(scope.row, 'show')" v-if="scope.row.state == 1">查看
                            </div>
                            <span
                                v-if="(!roleCheck('103-102-102-102') && !roleCheck('103-102-102-103') && scope.row.state != 1) || scope.row.state == -1">--</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>

            <Gh-Dialog ref="dislog" size="big" :title="dislog.title" @dialogBack="updateConfirm">
                <template v-slot:content >
                    <el-form label-width="100px" :model="actData" ref="formRule" :rules="formRule" v-if="dislog.type == 'update' || dislog.type == 'add'">
                        <el-form-item label="标题" prop="msg_title">
                            <el-input v-model="actData.msg_title" maxlength="100" placeholder="请输入消息推送标题"></el-input>
                        </el-form-item>
                        <el-form-item label="内容" prop="msg_desc">
                            <el-input v-model="actData.msg_desc" maxlength="1000" type="textarea" rows="5"
                                placeholder="请输入消息推送内容">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="跳转方式">
                            <el-radio v-model="actData.jump_type" label="H5">内部H5</el-radio>
                            <el-radio v-model="actData.jump_type" label="WEB">外部浏览器</el-radio>
                            <el-radio v-model="actData.jump_type" label="">不跳转</el-radio>
                        </el-form-item>
                        <el-form-item label="跳转地址" v-show="['H5', 'WEB'].includes(actData.jump_type)">
                            <el-input v-model="actData.jump_url" placeholder="请输入跳转链接"></el-input>
                        </el-form-item>
                        <el-form-item label="发送群组" prop="group" class="is-required">
                            <el-select v-model="group" placeholder="请选择" multiple>
                                <el-option v-for="(item, i) in groupList" :key="i + '142'" :label="item.group_name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发送时间" prop="start_time" class="is-required">
                            <el-date-picker v-model="actData.start_time" type="datetime" :editable="true"
                                format="yyyy-MM-dd HH:mm" placeholder="选择时间" :picker-options="pickerOptions"
                                value-format="timestamp" popper-class="time">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <el-form label-width="100px" :model="actData" label-position="left" v-if="dislog.type == 'show'">
                        <el-form-item label="标题：">
                            <span>{{actData.msg_title}}</span>
                        </el-form-item>
                        <el-form-item label="内容：">
                            <span>{{actData.msg_desc}}</span>
                        </el-form-item>
                        <el-form-item label="跳转方式：">
                            <span v-if="actData.jump_type=='H5'">内部H5</span>
                            <span v-else-if="actData.jump_type=='WEB'">外部浏览器</span>
                            <span v-else>不跳转</span>
                        </el-form-item>
                        <el-form-item label="跳转地址：" v-show="['H5', 'WEB'].includes(actData.jump_type)">
                            <span>{{actData.jump_url}}</span>
                        </el-form-item>
                        <el-form-item label="发送群组：">
                            <span>{{actData.group_name.join(';')}}</span>
                        </el-form-item>
                        <el-form-item label="发送时间：">
                            <span>{{ formDate(actData.start_time, 'YYYY-MM-DD HH:mm') }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
            <Tip ref="delTip" msg="确定要删除问题吗，删除后不能再恢复哦！" @tipBack="tipBack"></Tip>
        </div>
    </div>
</template>
<script>
export default ({
    name: 'msg-manage',
    data() {
        return {
            searchData: {
                page_size: 10,
                page: 1,
                name: '',
                state: '',
            },
            listData: [],
            groupList: [],
            total: 0,
            dislog: {
                type: '',
                title: ''
            },
            group: [],
            actData: {},
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                },
            },
            formRule: {
                msg_title: [this.requiredRule('请输入推送标题')],
                msg_desc: [this.requiredRule('请输入推送内容')],
                // group: [this.requiredRule('请选择发送人群','change','array')],
                // start_time: [this.requiredRule('请选择发送时间','change','date')]
            },
            delId: '',
        }
    },
    created() {
        this.getMsg();
        this.getGroupList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getMsg();
        },
        addPush() {
            this.dislog = {
                type: 'add',
                title: '新增消息推送'
            };
            this.actData = {
                msg_title: '',
                msg_desc: '',
                jump_type: 'H5',
                jump_url: '',
                group_list: '',
                start_time: '',
            };
            this.group = [];
            this.$refs.dislog.show = true;
        },
        getMsg() {
            this.api.getPushList(this.searchData).then(data => {
                this.listData = data.data.result;
                this.total = data.data.total;
            })
        },
        msgShow(row, type) {
            this.dislog = {
                type: type,
                title: type == 'update' ? '编辑推送消息' : '查看推送消息'
            };
            this.actData = {
                id: row.id,
                msg_title: row.msg_title,
                msg_desc: row.msg_desc,
                jump_type: row.jump_type,
                jump_url: row.jump_url,
                group_list: '',
                start_time: row.start_time,
                group_name: row.group_name
            };
            this.group = row.group_list ? row.group_list.split(';').map(Number) : [];
            this.$refs.dislog.show = true;
        },
        updateConfirm() {
            // console.log(this.group);
            this.$refs.formRule.validate(v => {
                if (v) {
                    if (this.actData.jump_type != '' && !this.actData.jump_url) {
                        this.$message.warning('请输入跳转地址!');
                        return;
                    }if (this.group.length == 0) {
                        this.$message.warning('请选择发送群组!');
                        return;
                    }if (!this.actData.start_time) {
                        this.$message.warning('请选择发送时间（需选择当前时间5分钟后）!');
                        return;
                    }
                    // if (new Date(this.actData.start_time).getTime() < new Date().getTime() + 5 * 60000) {
                    //     this.$message.warning('发送时间需选择当前时间5分钟后!');
                    //     return;
                    // }
                   
                    this.actData.group_list = this.group.join(';')
                    delete this.actData.group_name;
                    console.log(this.actData);
                    // this.actData.group_name = this.actData.group_name.split(';')
                    if (this.actData.id) {
                        this.actData.id = parseInt(this.actData.id)
                    }
                    // console.log(this.actData);
                    // return;
                    this.api.updatePush(this.actData).then(data => {
                        this.$message.success('操作成功！');
                        this.getMsg();
                        this.$refs.dislog.show = false;
                    })
                }
            });
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getMsg();
        },
        getGroupList() {
            this.api.getGroupList({}).then(data => {
                this.groupList = data.data.result || [];
            })
        },
        del(id) {
            this.$refs.delTip.show = true;
            this.delId = id;
        },
        tipBack() {
            this.api.delPush({ id: this.delId }).then(data => {
                this.$message.success('删除成功!');
                this.getMsg();
                this.$refs.delTip.show = false;
            });
        },
    }
})
</script>
<!-- <style>
.time .el-picker-panel__footer .el-button--text {
    display: none;
}
</style> -->
<style lang="less" scoped>
.margin_top {
    margin-top: 10px;
}

.status1 {
    color: #507FF7;
}

.status0 {
    color: #F8AF0C;
}

.status2 {
    color: #00D6B9;
}

.status3 {
    color: #EB534B;
}
</style>



// WEBPACK FOOTER //
// src/view/app/market-manage/msg-manage.vue